import { useState, useCallback } from 'react';
import { Photo } from '../../Hooks/UsePhotos';

interface Modals {
	viewPhoto: boolean;
	confirmDelete: boolean;
	confirmBatchDelete: boolean;
}

export function usePhotoModals() {
	const [modals, setModals] = useState<Modals>({
		viewPhoto: false,
		confirmDelete: false,
		confirmBatchDelete: false,
	});

	const [photoToDelete, setPhotoToDelete] = useState<Photo | null>(null);
	const [currentPhoto, setCurrentPhoto] = useState<Photo | null>(null);

	const openViewPhoto = useCallback((photo: Photo) => {
		setCurrentPhoto(photo);
		setModals((prev) => ({ ...prev, viewPhoto: true }));
	}, []);

	const closeViewPhoto = useCallback(() => {
		setCurrentPhoto(null);
		setModals((prev) => ({ ...prev, viewPhoto: false }));
	}, []);

	const openDeleteConfirm = useCallback((photo: Photo) => {
		setPhotoToDelete(photo);
		setModals((prev) => ({ ...prev, confirmDelete: true }));
	}, []);

	const closeDeleteConfirm = useCallback(() => {
		setPhotoToDelete(null);
		setModals((prev) => ({ ...prev, confirmDelete: false }));
	}, []);

	const openBatchDeleteConfirm = useCallback(() => {
		setModals((prev) => ({ ...prev, confirmBatchDelete: true }));
	}, []);

	const closeBatchDeleteConfirm = useCallback(() => {
		setModals((prev) => ({ ...prev, confirmBatchDelete: false }));
	}, []);

	return {
		modals,
		photoToDelete,
		currentPhoto,
		openViewPhoto,
		closeViewPhoto,
		openDeleteConfirm,
		closeDeleteConfirm,
		openBatchDeleteConfirm,
		closeBatchDeleteConfirm,
	};
}
